import React, { useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUserAuthAction } from '../../actions/authActions';
import styles from './Auth.module.scss';
import { TOOL_ID } from '../../actions';

export default function SwitchIndex() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { userAuth, error } = useSelector((state) => state.auth);
  const getUser = useCallback(() => {
    getUserAuthAction(dispatch);
  }, [dispatch]);

  const clearError = useCallback(() => {
    dispatch({
      type: 'ERROR_AUTH',
      payload: null,
    });
  }, [dispatch]);

  useEffect(() => {
    getUser();
    return () => {
      clearError();
    };
  }, [getUser, clearError]);

  useEffect(() => {
    if (userAuth?.tools?.find((p) => p.tool === TOOL_ID)) {
      history.push('/variation');
    }
  }, [userAuth]);

  useEffect(() => {
    if (error === 401) {
      history.push('/login');
    }
  }, [error]);

  return (
    <div className={styles.container}>
    </div>
  );
}
